import { routerStyxie } from '@/router/styxieBridge'
import { useMlapProjectStore } from '@/stores/mlapProject'

// Client-side routed under the project layout; the payload only seeds the
// project store (see router/routes/mlap.js).
Styxie.Initializers.MlapProjectsRevenueCorrelation = routerStyxie({
  actions: ['show'],
  hydrate: (props, pinia) => useMlapProjectStore(pinia).hydrate(props.project)
})
